(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ycoa-edit"] && !Shopify.designMode) return;
  try {
    
  function initYcoaTabs(root=document){root.querySelectorAll('[data-yc-tabs]').forEach(group=>{if(group.dataset.ready)return;group.dataset.ready='true';const tabs=[...group.querySelectorAll('[role=tab]')];const activate=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();activate(tabs[n]);tabs[n].focus();}});});});}
  initYcoaTabs();document.addEventListener('shopify:section:load',()=>initYcoaTabs());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ycoa-styles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ycoa-mood-slider')) {
  customElements.define('ycoa-mood-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.yv-styles__grid');
      this.cards = [...this.querySelectorAll('.yv-style')];
      if (!this.cards.length) return;
      this.prev = this.querySelector('[data-mood-prev]');
      this.next = this.querySelector('[data-mood-next]');
      this.status = this.querySelector('[data-mood-status]');
      const update = () => {
        const left = this.track.getBoundingClientRect().left;
        this.index = this.cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? index : best, 0);
        this.prev.disabled = this.index === 0;
        this.next.disabled = this.index === this.cards.length - 1;
        this.status.textContent = `${this.index + 1} / ${this.cards.length}`;
      };
      const move = direction => {
        const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, this.index + direction))];
        this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 4, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.prev.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !matchMedia('(max-width: 749px)').matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      window.addEventListener('resize', update, options);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
